<template>
  <DocumentTypeTable
      :items="items"
      @operation="onOperation"
  />
</template>

<script>
  import DocumentTypeTable from './DocumentTypeTable.vue';
  import {API} from "../../../../helpers/api-endpoints";
  import {Operations} from "../../../../helpers/roles";

  export default {
    name: 'DocumentTypeList',
    components: { DocumentTypeTable },
    data() {
      return {
        items: [],
      };
    },
    mounted() {
      this.load();
    },
    methods: {
      async load() {
        this.$loading(true);
        try {
          const { data } = await this.$http.post(
              API.DOCUMENT_TYPE_SEARCH,
              { offset: 0, max: 50, selectFields: ['*'] }
          );
          this.items = data.resultList || [];
        } finally {
          this.$loading(false);
        }
      },

      onOperation({ type, payload }) {
        switch (type) {
          case Operations.CREATE:
            this.$router.push({ name: 'adminDocumentTypeCreate' });
            break;

          case Operations.VIEW:
            this.$router.push({
              name: 'adminDocumentTypeView',
              params: { code: payload }
            });
            break;
        }
      }
    }
  };
</script>
